import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import AppBody from "../components/AppBody";
import DatePicker from "react-datepicker";
import { createTraining } from "../../actions/learning_provider/training_action";
import "react-datepicker/dist/react-datepicker.css";
import { Link, Navigate } from "react-router-dom";
import { getServicePrices } from "../../actions/admin/service/service_action";

const CreateTrainingPage = () => {
  const serviceState = useSelector((state) => state.serviceReducer);
  const [service, setService] = useState([]);
  const [traning, setTraining] = useState({
    name: "",
    start_date: new Date(),
    end_date: "",
    description: "",
    total_training_day: "",
    number_of_participants: ""
  });

  useEffect(() => {
    dispatch(getServicePrices());
  }, [])

  const [assessment, setAssessment] = useState({
    type: "",
    identified: "",
    end_date: "",
    beginner_question: "",
    intermediate_question: "",
    advanced_question: ""
  });

  const [requirement, setRequirement] = useState("");
  const [requirementList, setRequirementList] = useState([]);

  const dispatch = useDispatch();
  const state = useSelector((state) => state.trainingReducer);
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(createTraining({ ...traning, requirements: requirementList }));
  };

  const handleAutomaticQuestionAdd = () => {
    dispatch(createTraining({ ...traning, requirements: requirementList }));
  };

  if (state.is_done) {
    // setTraining({
    //   name: "",
    //   date: "",
    //   description: "",
    // });
    return <Navigate to="/all-trainings" />;
  }

  const addRequirementToLits = () => {
    if (requirement) {
      requirementList.push(requirement);
      setRequirement(" ");
    }
  };
  const deleteRequirementItem = (name) => {
    const arr = requirementList.filter(function (item) {
      return item !== name;
    });
    setRequirementList(arr);
    setTraining({ ...traning, requirements: requirementList });
  };
  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <Link
                  to={"/create-training"}
                  className="d-inline-block mt-2"
                ></Link>
                <h4 className="font-xs text-white fw-600  mb-0 mt-2">
                  Create Training Request
                </h4>
              </div>
              <div className="card-body w-100 border-0 ">
                <ul class="nav nav-tabs">
                  <li class="active">
                    <a data-toggle="tab" href="#home" aria-expanded="true">
                      Create Training
                    </a>
                  </li>
                  <li>
                    <a data-toggle="tab" href="#menu1">
                      Cost
                    </a>
                  </li>
                </ul>

                <div class="tab-content">
                  <div id="home" className="tab-pane fade in active show">
                    <h3>HOME</h3>
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-lg-12 mb-2">
                          <div className="form-group">
                            <label className="mont-font fw-600 font-xsss">
                              Training Name
                            </label>
                            <input
                              placeholder="Enter Training Name..."
                              type="text"
                              className="form-control"
                              value={traning.name}
                              onChange={(e) =>
                                setTraining({
                                  ...traning,
                                  name: e.target.value
                                })
                              }
                            />
                            <span className="error-msg">
                              {state.errors ? state.errors.name : ""}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-3 mb-2">
                          <div className="form-group">
                            <label className="mont-font fw-600 font-xsss">
                              Start Date & Time
                            </label>
                            <DatePicker
                              className="form-control"
                              selected={traning.start_date}
                              minDate={new Date()}
                              onChange={(date) =>
                                setTraining({ ...traning, start_date: date })
                              }
                              showTimeSelect
                              dateFormat="Pp"
                            />
                            <span className="error-msg">
                              {state.errors ? state.errors.start_date : ""}
                            </span>
                          </div>
                        </div>
                        <div className="col-lg-3 mb-2">
                          <div className="form-group">
                            <label className="mont-font fw-600 font-xsss">
                              End Date & Time
                            </label>
                            <DatePicker
                              className="form-control"
                              selected={traning.end_date}
                              minDate={traning.start_date}
                              onChange={(date) =>
                                setTraining({ ...traning, end_date: date })
                              }
                              showTimeSelect
                              dateFormat="Pp"
                            />
                            <span className="error-msg">
                              {state.errors ? state.errors.end_date : ""}
                            </span>
                          </div>
                        </div>
                        <div className="col-lg-3 mb-2">
                          <div className="form-group">
                            <label className="mont-font fw-600 font-xsss">
                              Total Training Days
                            </label>
                            <input
                              placeholder="Enter Training Days"
                              type="text"
                              className="form-control"
                              value={traning.total_training_day}
                              onChange={(e) =>
                                setTraining({
                                  ...traning,
                                  total_training_day: e.target.value
                                })
                              }
                            />
                            <span className="error-msg">
                              {state.errors
                                ? state.errors.total_training_day
                                : ""}
                            </span>
                          </div>
                        </div>
                        <div className="col-lg-3 mb-2">
                          <div className="form-group">
                            <label className="mont-font fw-600 font-xsss">
                              No Of Participants
                            </label>
                            <input
                              placeholder="Enter No Of Participants"
                              type="text"
                              className="form-control"
                              value={traning.number_of_participants}
                              onChange={(e) =>
                                setTraining({
                                  ...traning,
                                  number_of_participants: e.target.value
                                })
                              }
                            />
                            <span className="error-msg">
                              {state.errors
                                ? state.errors.number_of_participants
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-8 mb-3">
                          <label className="mont-font fw-600 font-xsss">
                            Training Requirements
                          </label>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Requirement Name eg DevOps, HTML,JAVA"
                              value={requirement}
                              onChange={(e) => setRequirement(e.target.value)}
                            />
                            <span className="error-msg">
                              {state.errors.requirements
                                ? state.errors.requirements
                                : ""}
                            </span>
                          </div>
                        </div>
                        <div className="col-lg-4 pt-2">
                          <input
                            type="button"
                            name="submit"
                            value="Add"
                            className="btn-common px-3 mt-30"
                            onClick={() => addRequirementToLits()}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-12 mb-3">
                          <ul>
                            {requirementList.map((topic, i) => (
                              <li key={i}>
                                <span className={"pt-2"}>{topic}</span>
                                <button
                                  className="btn approve_btn btn-common"
                                  type="button"
                                  onClick={() => deleteRequirementItem(topic)}
                                >
                                  Delete
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-12 mb-2">
                          <label className="mont-font fw-600 font-xsss">
                            Description
                          </label>
                          <textarea
                            className="form-control mb-0 p-3 h100 lh-16"
                            rows="2"
                            placeholder="Write your message..."
                            spellCheck="true"
                            onChange={(e) =>
                              setTraining({
                                ...traning,
                                description: e.target.value
                              })
                            }
                            value={traning.description}
                          />
                          <span className="error-msg">
                            {state.errors ? state.errors.description : ""}
                          </span>
                        </div>
                        <div className="col-lg-12 my-3">
                          <input
                            type="submit"
                            name="submit"
                            value="Submit"
                            className="btn-common px-5"
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                  <br />
                  <br />


                  <div id="menu1" class="tab-pane fade">
                    <h1>Cost</h1>
                    {
                      serviceState?.servicePrice && serviceState.servicePrice.map((li, i) => (
                        <div>
                          <input type="checkbox" value={li?.service} onChange={() => setService({ ...li, li })} /> <label>{li?.service}:{li?.price}</label><br />
                        </div>
                      ))}
                    <h1>Total Cost: </h1>
                    <br />
                    <div className="col-lg-12 my-3">
                      <input
                        type="submit"
                        name="submit"
                        value="Submit"
                        className="btn-common px-5"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default CreateTrainingPage;
